import { http } from "../../../http-common";
import {
    IReminderPageResponse,
    IReminderRequest,
    IReminderRequestEdit,
    IReminderResponse,
} from "../Types/Reminder";


const getAll = (query:string) => {
    return http.get<IReminderPageResponse>(`/reminders${query}`, );
};

const create = (data: IReminderRequest) => {
    return http.post<IReminderResponse>(`/accounts/me/reminders`, data);
};

const update = (id: number | string, data: IReminderRequestEdit) => {
    return http.put<IReminderResponse>(`/reminders/${id}`, data);
};

const remove = (id: number) => {
    return http.delete<IReminderResponse>(`/reminders/${id}`);
};

const ReminderService = {
    getAll,
    create,
    update,
    remove
};

export default ReminderService;
